export enum UserSortEnum {
  Id = 'id',
  CreatedAt = 'createdAt',
  Name = 'name',
  Role = 'role',
  Email = 'email',
  Status = 'status',
}
